// extracted by mini-css-extract-plugin
export default {"page__container":"BroadcastForm_page__container__ARJND"};